<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="discount-details">
      <div class="row">
				<div class="col-md-12">
          <h3 v-if="discount.code">{{ discount.code }}</h3>
          <h3 v-else>{{ _('New Discount') }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row">
        <div class="col-xs-12">
          <hr/>
          <h3>{{ _('General') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 leftcol">
          <div class="form-group">
            <label for="code">{{ _('Code') }}</label>
            <div class="input-group">
              <input id="discountCode" class="form-control" name="code" type="text" v-model="discount.code" />
              <span class="input-group-btn">
                <button class="btn btn-success" type="button" id="generateCode" v-on:click="generateCode">{{ _('Generate') }}</button>
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="amount">{{ _('Discount') }}</label>
            <div class="input-group single-line">
              <input id="discountAmount" class="form-control" name="amount" type="text" v-model="discount.amount" />
              <div class="input-group-btn">
                <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right">
                  <template #trigger>
                    <span id="discountTarget" v-if="!parseInt(discount.unit)">{{ _('Percent') }}</span><span id="discountTarget" v-else>{{ settings.currency }}</span> <span class="caret"></span>
                  </template>
                  <li><a id="setDiscountPercent" v-on:click="discount.unit = 0">{{ _('Percent') }}</a></li>
                  <li><a id="setDiscountEuros" v-on:click="discount.unit = 1">{{ settings.currency }}</a></li>
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="discountType">{{ _('Discount type') }}</label>
            <select id="discountType" class="form-control" v-model="discount.type">
              <option id="discountOrderlevel" value="0">{{ _('Order-level') }}</option>
              <option id="discountProductlevel" value="1">{{ _('Product-level') }}</option>
              <option id="discountProductlevelUnlimited" value="2" :disabled="!isMultiplyEnabled">{{ _('Product-level') }} ({{ _('multiply by product count') }})</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="usage">{{ _('Usage') }}</label>
            <select class="form-control" name="usage" id="usageSelector" v-model="discount.usage">
              <option value="0">{{ _('Permanent') }}</option>
              <option value="1">{{ _('Single use') }}</option>
              <option value="2">{{ _('Multi use') }}</option>
            </select>
          </div>
          <div>
            <p>{{ _('The usage setting sets the number of orders this code is valid for.') }}</p>
          </div>
          <div class="form-group" v-if="isRemainingVisible">
            <label for="remaining">{{ _('Remaining uses') }}</label>
            <input id="remaining" class="form-control" name="remaining" type="number" data-android-inputmode="decimal" v-model.number="discount.remaining" />
          </div>
          <div class="form-group">
            <label for="valid_date">{{ _('Valid until') }}</label>
            <DatePicker v-if="discount" v-model="validUntil" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select date')"></DatePicker>
          </div>
        </div>
      </div>
      <div class="row content_discount_right_wrapper">
        <div class="col-xs-12"><hr/></div>
        <div class="col-sm-6 leftcol">
          <h3>{{ _('Billing Customers') }}</h3>
          <p>{{ _('Select the billing customers that you want this discount code to be available for and append them here.') }}</p>
          <div id="billingcustomerList" class="list-group">
            <a href="javascript:;" class="list-group-item content_discount_billingcustomer" v-for="bc in discount.sharedBillingcustomer"><h4 class="list-group-item-heading"><span class="removeBillingcustomer fa fa-fw fa-close pull-right" v-on:click="removeBillingcustomer(bc)"></span><i class="fa fa-fw fa-building-o"></i> {{ bc.company }}</h4></a>
          </div>
          <div class="input-group">
            <span class="input-group-btn">
              <button type="button" class="btn btn-info" id="addBillingcustomer" v-on:click="selectBillingcustomer"><i class="fa fa-fw fa-link"></i> {{ _('Add billing customer') }}</button>
            </span>
          </div>
        </div>
        <div class="col-sm-6 rightcol" v-if="!isOrderLevel">
          <h3>{{ _('Products') }}</h3>
          <p>{{ _('Select the products that you want this discount code to be available for and append them here.') }} {{ _('You can also select categories to include all local products contained in them.')}}</p>
          <div id="categoryList" class="list-group">
            <a href="javascript:;" class="list-group-item content_discount_category" v-for="category in discount.sharedCategory"><h4 class="list-group-item-heading"><span class="removeCategory fa fa-fw fa-close pull-right" v-on:click="removeCategory(category)"></span><i class="fa fa-fw fa-folder-open"></i> {{ category.name }}</h4></a>
          </div>
          <div id="productList" class="list-group">
            <a href="javascript:;" class="list-group-item content_discount_product" v-for="product in discount.sharedProduct"><h4 class="list-group-item-heading"><span class="removeProduct fa fa-fw fa-close pull-right" v-on:click="removeProduct(product)"></span><i class="fa fa-fw fa-cubes"></i> {{ product.name }}</h4></a>
          </div>
          <div class="flex-row">
            <button type="button" class="btn btn-info" id="addProduct" v-on:click="selectProduct"><i class="fa fa-fw fa-link"></i> {{ _('Add product') }}</button>
            <button type="button" class="btn btn-info" id="addCategory" v-on:click="selectCategory"><i class="fa fa-fw fa-link"></i> {{ _('Add category') }}</button>
          </div>
          <div>
            <hr>
            {{ _('Discount is given for every matching product in an order and it is applied by product basis, not by product count. The total sum for each product is used as the base value from which the discount is calculated.') }}
          </div>
        </div>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the discount code? Deletion can\'t be undone.'))" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs"> {{ _('Delete discount code') }}</span></button>
        <div class="button-col">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'
import { BillingCustomerSelector, CategorySelector, ProductSelector } from '#components'

export default {
  data () {
    return {
      discount: {}
    }
  },
  mixins: [changewatcher, components],
  computed: {
    isMultiplyEnabled () {
      return this.discount && parseInt(this.discount.unit) !== 0
    },
    isRemainingVisible () {
      return this.discount && parseInt(this.discount.usage) === 2
    },
    isOrderLevel () {
      return this.discount && parseInt(this.discount.type) === 0
    },
    validUntil: {
      get () {
        if (!this.discount || !parseInt(this.discount.valid_ts, 10)) {
          return null
        }
        return DateTime.fromSeconds(Number(this.discount.valid_ts), { zone: this.timezone }).toJSDate()
      },
      set (newValue) {
        this.discount.valid_ts = DateTime.fromJSDate(newValue, { zone: this.timezone }).toUnixInteger()
      }
    }
  },
  methods: {
    getSaveData () {
      const exportFields = [
        'id',
        'code',
        'amount',
        'unit',
        'type',
        'usage',
        'remaining',
        'valid_ts',
        'sharedProduct',
        'sharedCategory',
        'sharedBillingcustomer'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.discount[e], a), {})
      data.valid_ts = data.valid_ts ? parseInt(data.valid_ts, 10) : null
      data.source = 'editor'
      return data
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/discounts/' + this.discount.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the discount code failed!'))
      }
      this.showNotification(this._('Discount code deleted!'))
      this.close()
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/discounts/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/discounts.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadDiscount(response.data.id)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadDiscount (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/discounts/' + id + '.json?products=true&billingcustomers=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.discount = response.data
        if (!this.discount.sharedBillingcustomer) {
          this.discount.sharedBillingcustomer = []
        }
        this.storeState()
        this.loading = false
        resolve(this.discount)
      })
    },
    generateRandomString(length) {
      let s = ''
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ123456789' // don't use I, O or 0
      for (let i = 0; i < length; i++) {
        s += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return s
    },
    generateCode () {
      this.discount.code = this.generateRandomString(10)
    },
    selectProduct () {
      this.showModal('productselector', ProductSelector, {
        props: {
          selectedProducts: this.discount.sharedProduct.map(p => { return { id: p.id } }),
          showLinkedProduct: false
        },
        events: {
          selectProduct: this.addProduct
        },
        handlers: {},
        width: 800
      })
    },
    addProduct (product) {
      this.discount.sharedProduct.push(product)
    },
    removeProduct (product) {
      this.discount.sharedProduct = this.discount.sharedProduct.filter(p => p.id !== product.id)
    },
    selectCategory () {
      this.showModal('categoryselector', CategorySelector, {
        props: {
          selectedCategories: this.discount.sharedCategory.map(c => { return { id: c.id } })
        },
        events: {
          selectCategory: this.addCategory
        },
        handlers: {},
        width: 800
      })
    },
    addCategory (category) {
      this.discount.sharedCategory.push(category)
    },
    removeCategory (category) {
      this.discount.sharedCategory = this.discount.sharedCategory.filter(c => c.id !== category.id)
    },
    selectBillingcustomer () {
      this.showModal('billingcustomerselector', BillingCustomerSelector, {
        props: {
          selectedBillingcustomers: this.discount && this.discount.sharedBillingcustomer ? this.discount.sharedBillingcustomer.map(c => { return { id: c.id } }) : []
        },
        events: {
          selectBillingcustomer: this.addBillingcustomer
        },
        handlers: {},
        width: 800
      })
    },
    addBillingcustomer (billingcustomer) {
      this.discount.sharedBillingcustomer.push(billingcustomer)
    },
    removeBillingcustomer (billingcustomer) {
      if (!this.discount.sharedBillingcustomer) {
        this.discount.sharedBillingcustomer = []
      }
      this.discount.sharedBillingcustomer = this.discount.sharedBillingcustomer.filter(c => c.id !== billingcustomer.id)
    }
  },
  components: {
    BillingCustomerSelector,
    CategorySelector,
    ProductSelector
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadDiscount(this.component.initData.discountId)
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.discount && this.discount.id && parseInt(this.discount.id, 10) !== parseInt(this.component.initData.discountId, 10)) {
        try {
          await this.loadDiscount(this.component.initData.discountId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['discountUpdate'] = async (message) => {
        if (message && message.data && this.discount && parseInt(message.data.id, 10) === parseInt(this.discount.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadDiscount(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
}
</script>
